import { useState } from "react";
import { Trash } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export const ConfirmDelete = ({ label, title, desc, typed, onConfirm, testid }) => {
  const [txt, setTxt] = useState("");
  return (
    <AlertDialog onOpenChange={() => setTxt("")}>
      <AlertDialogTrigger asChild><Button variant="ghost" data-testid={testid} className="gap-1 text-[#FF3B30] hover:text-[#FF6961]"><Trash /> {label}</Button></AlertDialogTrigger>
      <AlertDialogContent className="bg-[#121212] border-border">
        <AlertDialogHeader><AlertDialogTitle>{title}</AlertDialogTitle><AlertDialogDescription>{desc}</AlertDialogDescription></AlertDialogHeader>
        {typed && <Input data-testid={`${testid}-input`} value={txt} onChange={(e) => setTxt(e.target.value)} placeholder={`Type ${typed}`} className="bg-black" />}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testid}-confirm`} disabled={typed && txt !== typed} onClick={() => onConfirm(txt)} className="bg-[#FF3B30] hover:bg-[#FF6961]">Delete</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
